import { render, staticRenderFns } from "./NotificationMessages.vue?vue&type=template&id=a873097a&scoped=true"
import script from "./NotificationMessages.vue?vue&type=script&lang=ts"
export * from "./NotificationMessages.vue?vue&type=script&lang=ts"
import style0 from "./NotificationMessages.vue?vue&type=style&index=0&id=a873097a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a873097a",
  null
  
)

export default component.exports